<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/6MAdLl/images/cover.jpg?1703000774429" alt="This image is the cover for the book Peppercorn, His Life & Locomotives"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Peppercorn, His Life & Locomotives
      </h1>
      <p class="bookDescription body article font2">
        <p>Arthur Peppercorn, a vicar's son from Herefordshire, was the last L N E R Chief Mechanical Engineer.  He managed his department for a very short time before it was swept away in the wholesale changes that followed Nationalisation of British Railways in 1948.Although a disciple and follower of Sir Nigel Gresley, he was his own man and developed his talent for production engineering that fully complimented the design skills of his greatly respected leader.  He then became a worthy deputy to Edward Thompson during a war that demanded great personal sacrifices from both men.  When he finally became C M E in 1946 he used his wide talents and experience to lead in developing two successful pacific classes of locomotives, that many rate as being among the best locomotives of this type ever to appear in Britain.  This book, which is the first detailed biography of Peppercorn, tells his fascinating story and describes the influences on his life and career, illustrating his many achievements along the way.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Tim Hillier-Graves
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Pen and Sword Transport
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?529327bf